(function () {
  'use strict';

  var existingApi = window.BeardAndBonesNotifyMe;
  if (existingApi) {
    existingApi.init(document);
    return;
  }

  var turnstilePromise = null;
  var TOKEN_MAX_AGE_MS = 4.5 * 60 * 1000;

  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (turnstilePromise) return turnstilePromise;

    turnstilePromise = new Promise(function (resolve, reject) {
      var script = document.querySelector('script[data-notify-turnstile-script]');
      var timeout = window.setTimeout(function () {
        if (script && !window.turnstile) script.remove();
        turnstilePromise = null;
        reject(new Error('Security check timed out.'));
      }, 12000);

      function loaded() {
        window.clearTimeout(timeout);
        if (window.turnstile) {
          resolve(window.turnstile);
        } else {
          turnstilePromise = null;
          reject(new Error('Security check is unavailable.'));
        }
      }

      function failed() {
        window.clearTimeout(timeout);
        if (script) script.remove();
        turnstilePromise = null;
        reject(new Error('Security check is unavailable.'));
      }

      if (script) {
        script.addEventListener('load', loaded, { once: true });
        script.addEventListener('error', failed, { once: true });
        return;
      }

      script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.dataset.notifyTurnstileScript = 'true';
      script.addEventListener('load', loaded, { once: true });
      script.addEventListener('error', failed, { once: true });
      document.head.appendChild(script);
    });

    return turnstilePromise;
  }

  function init(context) {
    var roots = [];
    if (context && context.matches && context.matches('.notify-me')) {
      roots.push(context);
    }
    if (context && context.querySelectorAll) {
      context.querySelectorAll('.notify-me').forEach(function (root) {
        roots.push(root);
      });
    }
    roots.forEach(initNotifyMe);
  }

  function initNotifyMe(root) {
    if (root.dataset.notifyInitialized === 'true') return;
    root.dataset.notifyInitialized = 'true';

    var apiBase = root.dataset.apiBase;
    var siteKey = root.dataset.turnstileSitekey;
    var overlay = root.querySelector('[data-notify-overlay]');
    var modal = overlay.querySelector('.notify-me__modal');
    var openBtn = root.querySelector('[data-notify-open]');
    var closeBtn = root.querySelector('[data-notify-close]');
    var focusStart = root.querySelector('[data-notify-focus-start]');
    var focusEnd = root.querySelector('[data-notify-focus-end]');
    var reasonEl = root.querySelector('[data-notify-reason]');
    var variantNameEl = root.querySelector('[data-notify-variant-name]');
    var currentPriceEl = root.querySelector('[data-notify-current-price]');
    var restockCard = root.querySelector('[data-notify-card="restock"]');
    var priceCard = root.querySelector('[data-notify-card="price_drop"]');
    var holder = root.closest('.product-block') || root;
    var productSection = root.closest('.product-section');
    var challengeStates = {};

    var state = {
      productId: root.dataset.productId,
      variantId: root.dataset.variantId,
      variantTitle: root.dataset.variantTitle,
      available: root.dataset.variantAvailable === 'true',
      price: root.dataset.variantPrice,
      showPriceDrop: root.dataset.showPriceDrop !== 'false'
    };

    root.querySelectorAll('[data-notify-form]').forEach(function (form) {
      var type = form.dataset.notifyForm;
      challengeStates[type] = createChallengeState(form, type);
      form.addEventListener('submit', function (event) {
        submitForm(event, form, type);
      });
    });

    syncUi();

    openBtn.addEventListener('click', function () {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      ensureActiveChallenge();
      var activeChallenge = challengeStates[activeType()];
      var firstInput = activeChallenge &&
        activeChallenge.form.querySelector('input[type="email"]:not([tabindex="-1"])');
      if (firstInput) firstInput.focus();
    });

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeModal();
    });
    overlay.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeModal();
        return;
      }
      if (event.key === 'Tab') trapModalFocus(event);
    });
    focusStart.addEventListener('focus', focusLastModalElement);
    focusEnd.addEventListener('focus', focusFirstModalElement);

    if (productSection) {
      productSection.addEventListener('variantChange', function (event) {
        var variant = event.detail && event.detail.variant;
        if (!variant) return;

        state.variantId = String(variant.id);
        state.variantTitle = variant.title || variant.name || '';
        state.available = Boolean(variant.available);
        state.price = (variant.price / 100).toFixed(2);

        root.dataset.variantId = state.variantId;
        root.dataset.variantAvailable = String(state.available);
        root.dataset.variantPrice = state.price;

        resetAllChallenges();
        syncUi();
        if (overlay.classList.contains('is-open')) ensureActiveChallenge();
      });
    }

    function createChallengeState(form, type) {
      var challenge = {
        form: form,
        type: type,
        mount: form.querySelector('[data-notify-turnstile]'),
        status: form.querySelector('[data-notify-security-status]'),
        submit: form.querySelector('.notify-me__submit'),
        widgetId: null,
        token: '',
        tokenCreatedAt: 0,
        loading: false,
        inFlight: false
      };
      challenge.submit.disabled = true;
      return challenge;
    }

    function closeModal() {
      var wasOpen = overlay.classList.contains('is-open');
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      if (wasOpen) openBtn.focus();
    }

    function activeType() {
      return state.available ? 'price_drop' : 'restock';
    }

    function ensureActiveChallenge() {
      ensureChallenge(challengeStates[activeType()]);
    }

    function hasFreshToken(challenge) {
      return Boolean(
        challenge.token &&
        Date.now() - challenge.tokenCreatedAt < TOKEN_MAX_AGE_MS
      );
    }

    function ensureChallenge(challenge) {
      if (!challenge) return;
      if (challenge.inFlight) {
        challenge.submit.disabled = true;
        return;
      }
      if (hasFreshToken(challenge)) {
        challenge.submit.disabled = false;
        return;
      }
      if (challenge.token) {
        resetChallenge(challenge, '');
        return;
      }
      if (challenge.widgetId !== null || challenge.loading) return;
      if (!siteKey) {
        setSecurityStatus(challenge, 'Security check is not configured. Please try again later.', true);
        return;
      }

      challenge.loading = true;
      setSecurityStatus(challenge, 'Loading security check…', false);
      loadTurnstile()
        .then(function (turnstile) {
          challenge.widgetId = turnstile.render(challenge.mount, {
            sitekey: siteKey,
            action: challenge.type === 'restock' ? 'notify_restock' : 'notify_price_drop',
            appearance: 'interaction-only',
            size: window.matchMedia('(max-width: 430px)').matches ? 'compact' : 'normal',
            callback: function (token) {
              challenge.token = token;
              challenge.tokenCreatedAt = Date.now();
              challenge.submit.disabled = challenge.inFlight;
              setSecurityStatus(challenge, '', false);
            },
            'expired-callback': function () {
              resetChallenge(challenge, 'Security check expired. Please try again.');
            },
            'error-callback': function () {
              resetChallenge(challenge, 'Security check failed. Please try again.');
              return true;
            },
            'timeout-callback': function () {
              resetChallenge(challenge, 'Security check timed out. Please try again.');
            },
            'before-interactive-callback': function () {
              setSecurityStatus(challenge, 'Please complete the security check.', false);
            }
          });
          challenge.loading = false;
        })
        .catch(function (error) {
          challenge.loading = false;
          setSecurityStatus(challenge, error.message, true);
        });
    }

    function resetChallenge(challenge, message) {
      challenge.token = '';
      challenge.tokenCreatedAt = 0;
      challenge.submit.disabled = true;
      if (window.turnstile && challenge.widgetId !== null) {
        try {
          window.turnstile.reset(challenge.widgetId);
        } catch (error) {
          challenge.widgetId = null;
          challenge.mount.textContent = '';
        }
      }
      setSecurityStatus(challenge, message || '', Boolean(message));
    }

    function trapModalFocus(event) {
      var focusable = getModalFocusable();
      if (!focusable.length) {
        event.preventDefault();
        closeBtn.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function getModalFocusable() {
      return Array.prototype.filter.call(modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
        'select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])'
      ), function (element) {
        return element.getClientRects().length > 0;
      });
    }

    function focusFirstModalElement() {
      var focusable = getModalFocusable();
      (focusable[0] || closeBtn).focus();
    }

    function focusLastModalElement() {
      var focusable = getModalFocusable();
      (focusable[focusable.length - 1] || closeBtn).focus();
    }

    function resetAllChallenges() {
      Object.keys(challengeStates).forEach(function (type) {
        resetChallenge(challengeStates[type], '');
      });
    }

    function setSecurityStatus(challenge, message, isError) {
      if (!challenge.status) return;
      challenge.status.textContent = message;
      challenge.status.classList.toggle('notify-me__security-status--error', isError);
    }

    function syncUi() {
      var showNotify = !state.available || state.showPriceDrop;
      holder.style.display = showNotify ? '' : 'none';
      root.style.display = showNotify ? '' : 'none';

      if (!showNotify) {
        closeModal();
        if (restockCard) restockCard.style.display = 'none';
        if (priceCard) priceCard.style.display = 'none';
        return;
      }

      if (variantNameEl) variantNameEl.textContent = state.variantTitle;

      if (state.available) {
        if (reasonEl) reasonEl.textContent = 'when the price drops';
        if (restockCard) restockCard.style.display = 'none';
        if (priceCard) priceCard.style.display = '';
        if (currentPriceEl) {
          currentPriceEl.textContent = window.theme && theme.Currency
            ? theme.Currency.formatMoney(parseFloat(state.price) * 100)
            : '£' + state.price;
        }
      } else {
        if (reasonEl) reasonEl.textContent = 'when back in stock';
        if (restockCard) restockCard.style.display = '';
        if (priceCard) priceCard.style.display = 'none';
      }
    }

    function submitForm(event, form, type) {
      event.preventDefault();

      var challenge = challengeStates[type];
      var emailInput = form.querySelector('input[type="email"]');
      var honeypot = form.querySelector('input[name="honeypot"]');
      var msgEl = root.querySelector('[data-notify-msg="' + type + '"]');
      var submitBtn = form.querySelector('.notify-me__submit');
      var textEl = submitBtn.querySelector('.notify-me__submit-text');
      var loadingEl = submitBtn.querySelector('.notify-me__submit-loading');
      var email = emailInput.value.trim();

      if (!email || !emailInput.checkValidity()) {
        showMsg(msgEl, 'Please enter a valid email address.', 'error');
        return;
      }
      if (!hasFreshToken(challenge)) {
        var securityMessage = challenge.token
          ? 'Security check expired. Please try again.'
          : 'Please complete the security check.';
        showMsg(msgEl, securityMessage, 'error');
        if (challenge.token) resetChallenge(challenge, securityMessage);
        ensureChallenge(challenge);
        return;
      }
      if (challenge.inFlight) return;

      var payload = {
        shopify_product_id: state.productId,
        variant_id: state.variantId,
        email: email,
        type: type,
        honeypot: honeypot ? honeypot.value : '',
        turnstile_token: challenge.token
      };

      if (type === 'price_drop') {
        var targetInput = form.querySelector('[data-notify-target-price]');
        if (targetInput && targetInput.value) {
          payload.target_price = parseFloat(targetInput.value);
        }
      }

      submitBtn.disabled = true;
      challenge.inFlight = true;
      textEl.style.display = 'none';
      loadingEl.style.display = '';

      fetch(apiBase + '/api/notifications/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json()
            .catch(function () {
              return {};
            })
            .then(function (body) {
              if (!response.ok) {
                throw new Error(body.error || 'Something went wrong. Please try again.');
              }
              return body;
            });
        })
        .then(function () {
          showMsg(
            msgEl,
            "You're all set! We'll email you when " +
              (type === 'restock' ? 'this is back in stock.' : 'the price drops.'),
            'success'
          );
          form.reset();
        })
        .catch(function (error) {
          showMsg(msgEl, error.message, 'error');
        })
        .finally(function () {
          challenge.inFlight = false;
          textEl.style.display = '';
          loadingEl.style.display = 'none';
          resetChallenge(challenge, '');
        });
    }

    function showMsg(element, text, type) {
      if (!element) return;
      element.textContent = text;
      element.className = 'notify-me__msg notify-me__msg--' + type;
    }
  }

  window.BeardAndBonesNotifyMe = { init: init };
  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
